import React from "react";
import { useNavigate } from "react-router-dom";
import translations from "../../locals/translations.json";
import { useLanguage } from "../../context/LanguageContext";
import api from "../../lib/api.ts";
import { getPaginatedProducts } from "../../services/vehicleServices.ts";
import VehiclesPage from "../VehiclesPage.jsx";
const SearchFilter = ({
  onSearchClick,
  containerBg = "bg-white",
  inputBg = "bg-white",
  shadow = "shadow-md shadow-gray-400",
  initialMake = "",
  initialModel = "",
  initialYear = "",
  initialSearchTerm = "",
  isHomepage = true,
  search,

  onSearchResults = () => {},
}) => {
  const [selectedMake, setSelectedMake] = React.useState(initialMake);
  const [selectedModel, setSelectedModel] = React.useState(initialModel);
  const [selectedYear, setSelectedYear] = React.useState(initialYear);
  const [searchTerm, setSearchTerm] = React.useState(initialSearchTerm || "");
  const { language } = useLanguage();
  const isRTL = language === "ar";
  const t = translations[language].search;
  const navigate = useNavigate();
  const [filters, setFilters] = React.useState({
    Make: [],
    Model: [],
  });
  const [searchResults, setSearchResults] = React.useState([]);
  // console.log("searchResults", searchResults);
  // const [searchTerm, setSearchTerm] = React.useState([]);

  // Fetch Makes
  React.useEffect(() => {
    const fetchFilters = async () => {
      try {
        const makeRes = await api.get(`/makes`);
        setFilters((prev) => ({ ...prev, Make: makeRes.data }));
      } catch (error) {
        console.error("Error fetching makes:", error);
      }
    };

    fetchFilters();
  }, []);

  // Fetch Models when Make changes
  React.useEffect(() => {
    if (!selectedMake) {
      setFilters((prev) => ({ ...prev, Model: [] }));
      return;
    }

    const fetchModels = async () => {
      try {
        const res = await api.get(`/models?makeId=${selectedMake}`);
        setFilters((prev) => ({ ...prev, Model: res.data }));
      } catch (error) {
        console.error("Error fetching models:", error);
      }
    };

    fetchModels();
  }, [selectedMake]);

  const handleSearch = async () => {
    if (isHomepage) {
      // Homepage: just navigate to vehicles page with filters
      const params = new URLSearchParams();
      if (selectedMake) params.append("makeId", selectedMake);
      if (selectedModel) params.append("modelId", selectedModel);
      if (selectedYear) params.append("year", selectedYear);
      if (searchTerm) params.append("search", searchTerm);

      navigate(`/vehicles?${params.toString()}`);
    } else {
      // Vehicles page: fetch and optionally set search results
      onSearchResults(selectedMake, selectedModel, selectedYear, searchTerm);

      return;
    }
  };
  return (
    <div className='-mt-10 relative z-10'>
      <div className='max-w-7xl mx-auto'>
        <div className='max-w-7xl mx-auto'>
          <div
            className={`${containerBg} h-auto ${shadow} p-6 mb-8`}
            dir={isRTL ? "rtl" : "ltr"}
            lang={language}
          >
            <div className='grid grid-cols-1 md:grid-cols-5 gap-6 font-Poppins font-medium text-[16px] text-[#131313CC]'>
              {/* Search box */}
              <div>
                <input
                  name='searchTerm'
                  value={searchTerm} // <-- This must be here!
                  onChange={(e) => setSearchTerm(e.target.value)}
                  type='text'
                  placeholder={t.searchPlaceholder}
                  className={`w-full px-4 py-2.5 rounded-lg text-[14px] font-normal text-[#131313] placeholder-[#888888] border-[#888888] border-[1px] focus:outline-none focus:ring-2 focus:ring-primary ${inputBg} ${
                    isRTL ? "text-right" : "text-left"
                  }`}
                  dir={isRTL ? "rtl" : "ltr"}
                />
              </div>

              {/* Make Dropdown */}
              <div className="relative">
                <select
                  className={`w-full px-4 py-2.5 rounded-lg text-[14px] font-normal text-[#131313] border-[#888888] border-[1px] focus:outline-none focus:ring-2 focus:ring-primary ${inputBg} appearance-none ${
                    isRTL ? "text-right pr-8" : "text-left pl-8"
                  }`}
                  value={selectedMake}
                  onChange={(e) => setSelectedMake(e.target.value)}
                  dir={isRTL ? "rtl" : "ltr"}
                >
                  <option value=''>{t.allMake}</option>
                  {(filters.Make || []).map((make) => (
                    <option
                      key={make.id || make._id}
                      value={make.id || make._id}
                    >
                      {make.name}
                    </option>
                  ))}
                </select>
                <div className={`absolute top-1/2 transform -translate-y-1/2 pointer-events-none ${
                  isRTL ? "left-2" : "right-2"
                }`}>
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              {/* Model Dropdown */}
              <div className="relative">
                <select
                  className={`w-full px-4 py-2.5 rounded-lg text-[14px] font-normal text-[#131313] border-[#888888] border-[1px] focus:outline-none focus:ring-2 focus:ring-primary ${inputBg} appearance-none ${
                    isRTL ? "text-right pr-8" : "text-left pl-8"
                  }`}
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                  dir={isRTL ? "rtl" : "ltr"}
                >
                  <option value=''>{t.allModel}</option>
                  {(filters.Model || []).map((model) => (
                    <option
                      key={model.id || model._id}
                      value={model.id || model._id}
                    >
                      {model.name}
                    </option>
                  ))}
                </select>
                <div className={`absolute top-1/2 transform -translate-y-1/2 pointer-events-none ${
                  isRTL ? "left-2" : "right-2"
                }`}>
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              {/* Year Dropdown */}
              <div className="relative">
                <select
                  className={`w-full px-4 py-2.5 rounded-lg text-[14px] font-normal text-[#131313] border-[#888888] border-[1px] focus:outline-none focus:ring-2 focus:ring-primary ${inputBg} appearance-none ${
                    isRTL ? "text-right pr-8" : "text-left pl-8"
                  }`}
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(e.target.value)}
                  dir={isRTL ? "rtl" : "ltr"}
                >
                  <option value=''>{t.selectYear}</option>
                  {Array.from({ length: 30 }, (_, i) => {
                    const year = new Date().getFullYear() - i;
                    return (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    );
                  })}
                </select>
                <div className={`absolute top-1/2 transform -translate-y-1/2 pointer-events-none ${
                  isRTL ? "left-2" : "right-2"
                }`}>
                  <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </div>
              </div>

              {/* Search Button */}
              <div
                className={`flex items-center ${
                  isRTL ? "space-x-reverse space-x-4" : "space-x-4"
                }`}
              >
                <div className='h-12  opacity-80' />
                <button
                  className='bg-darkGraybg flex items-center justify-center h-[48px] w-[188px] text-white px-6 py-3 hover:bg-primary-dark transition-all text-sm font-semibold'
                  onClick={handleSearch}
                >
                  {t.searchButton}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchFilter;
